<template>
  <nav
    v-show="displaySidebar"
    :class="{ 'fixed-left': displaySidebar }"
    class="navbar navbar-vertical navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img :src="logo" class="navbar-brand-img" alt="..." />
        <br />
      </router-link>
      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" position="right">
            <a slot="title" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="user logo" src="/img/pages/default_user.png" />
                </span>
              </div>
            </a>

            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Ações</h6>
            </div>
            <router-link
              :to="getFullPathBasedOnRole('configuracoes')"
              class="dropdown-item"
            >
              <i class="ni ni-single-02"></i>
              <span>Meu perfil</span>
            </router-link>
            <router-link
              :to="getFullPathBasedOnRole('suporte', 'mensagens')"
              class="dropdown-item"
            >
              <i class="ni ni-support-16"></i>
              <span>Suporte</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a @click="handleLogout" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Sair</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
        <!--Divider-->
        <hr class="my-3" />
        <!--Heading-->
        <h6 class="navbar-heading text-muted">Links</h6>
        <!--Navigation-->
        <ul class="navbar-nav mb-md-3">
          <li class="nav-item">
            <a
              class="nav-link"
              target="_blank"
              href="https://starsaceleradora.com.br/"
            >
              <i class="ni ni-spaceship"></i> Stars Aceleradora
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";
import { logout, getRoles } from "@/services/auth";

export default {
  name: "sidebar",
  components: {
    NavbarToggleButton,
  },
  props: {
    logo: {
      type: String,
      default: "/img/brand/logo_stars_black.png",
      description: "Sidebar app logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
    displaySidebar: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    getFullPathBasedOnRole(subpath, adminSubpath) {
      const roles = getRoles();
      if (roles) {
        const role = JSON.parse(roles)[0];
        if (role === "investor") return `/investidor/${subpath}`;
        else if (role === "administrator")
          return `/admin/${adminSubpath || subpath}`;
        else return `/${role}/${subpath}`;
      }
      return "/";
    },
    handleLogout() {
      logout();
      this.$toasted.show("Até breve! :)");
      this.$router.push("/");
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    toggleSidebar() {
      this.displaySidebar = !this.displaySidebar;
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style scoped>
.navbar-vertical .navbar-brand-img {
  max-height: 5rem !important;
}
</style>
<style>
.text-dark-yellow {
  color: #e69900;
}

.text-dark-green {
  color: seagreen;
}

.text-dark-purple {
  color: #6f42c1;
}
</style>
